import { customElement } from "lit/decorators.js";
import { Subheading } from "@/components/subheading";

@customElement("eko-empty-state-title")
class EmptyStateTitle extends Subheading {
  constructor() {
    super();

    this.size = "lg";
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-empty-state-title": EmptyStateTitle;
  }
}

export default EmptyStateTitle;
